/* eslint-disable */
const htmlEntities = {
  [`&amp;`]: 38,
  [`&sup3;`]: 179,
};

/**
 * Decode the input string with HTML entities
 * @returns {string} The decoded string
 * @param {string} stringWithHtmlEntities The input string with HTML entities
 */
const decodeHtmlEntities = (stringWithHtmlEntities) => {
  return Object.entries(htmlEntities).reduce((acc, [entity, unicodeNumber]) => {
    const pattern = new RegExp(entity, `g`);
    return acc.replace(pattern, String.fromCharCode(unicodeNumber));
  }, stringWithHtmlEntities);
};

export default decodeHtmlEntities;
